import React, { useEffect, useState, useRef } from "react";
import classes from "./Purchaseinvoice.module.css";
import HeaderNav from "../../Components/Dahboard Header/HeaderNav/HeaderNav";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import searchicon from "../../Assets/searchicon.png";
import filter from "../../Assets/filter.png";
import Footer from "../../Components/Footer/Footer";
import { Pen, Trash2, Printer } from "lucide-react";
import axios from "axios";
import { BASE_URL } from "../../Components/API/Api";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Button, Modal, Form, Spinner, Tab, Tabs, Row, Col, Popover } from 'react-bootstrap';
import Select from "react-select";
import crop from "../../Assets/repoort.png";
import PaymentModal from '../../Pages/Suppliers/PaymentModal';
import verified from "../../Assets/verified.svg";
import Swal from "sweetalert2";
import CurrencyInput from "react-currency-input-field";
import { isAccordionItemSelected } from "react-bootstrap/esm/AccordionContext";



const NewPaymentPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [tellerNo, setTellerNo] = useState("");
  const [invoices, setInvoices] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);
  const handleShow1 = () => setShow1(true);
  const handleShow2 = () => setShow2(true);
  const handleClose1 = () => setShow1(false);
  const handleClose2 = () => setShow2(false);
  const [selectedRadio, setSelectedRadio] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [paymentDate, setPaymentDate] = useState("");
  const [description, setDescription] = useState("");
  const [amount, setAmount] = useState("");
  const [bankOptions, setBankOptions] = useState([]);
  const [bankOptions2, setBankOptions2] = useState([]);
  const [paymentMode, setPaymentMode] = useState([]);
  const [selectedBank, setSelectedBank] = useState(null);
  const [selectedBank2, setSelectedBank2] = useState(null);
  const [selectedPaymentMode, setSelectedPaymentMode] = useState(null);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [invoiceOptions, setInvoiceOptions] = useState([]);
  const [addpaymenntLoad, setAddPaymenntLoad] = useState(false);
  const [addpaymenntLoad2, setAddPaymenntLoad2] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  // At the top of your component
  const [selectMetrics, setSelectedMetrics] = useState(null);

  // And use Option 1 for fetching

  const printRef = useRef();
  const pageMap = {
    "/dashboard": "Dashboard",
    "/transactions": "Transactions",
    "/accounts": "Accounting",
    "/reports": "Reports",
    "/banking": "Banking",
    "/settings": "Settings",
  };


  const handleRadioChange = (e) => {
    const value = e.target.value;
    setSelectedRadio(value);

    if (value === "general") {
      setSelectedCustomer(null);
    }
  };
  // replace tellerNo with chequeNo
  const [chequeNo, setChequeNo] = useState("");


  // useEffect(() => {
  //   const fetchInvoices = async () => {
  //     try {
  //       const token = localStorage.getItem("authToken");
  //       const res = await axios.get(`${BASE_URL}/v1/payments-made`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //             Accept: "application/json",
  //           },
  //         }
  //       );
  //       if (res.data && res.data.status && Array.isArray(res.data.data)) {
  //         setInvoices(res.data.data);
  //       }
  //     } catch (err) {
  //       // Optionally handle error
  //       setInvoices([]);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchInvoices();
  // }, []);


  const fetchInvoices = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const res = await axios.get(`${BASE_URL}/v1/payments-made`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      if (res.data && res.data.status && Array.isArray(res.data.data)) {
        setInvoices(res.data.data);
      }
    } catch (err) {
      setInvoices([]);
    } finally {
      setLoading(false);
    }
  };

  // load invoices on mount
  useEffect(() => {
    fetchInvoices();
  }, []);


  useEffect(() => {
    const fetchCurrencies = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await axios.get(`${BASE_URL}/v1/fetch-all-currencies`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });

        const options = Array.isArray(res.data.data)
          ? res.data.data.map((item) => ({
            value: item.id,
            label: item.name || item.code,
            code: item.code, // ✅ store code for default selection
          }))
          : [];

        setCurrencyOptions(options);

        // ✅ Automatically select NGN as default if available
        const ngnCurrency = options.find((opt) => opt.code === "NGN" || opt.label === "NGN");
        if (ngnCurrency) {
          setSelectedCurrency(ngnCurrency);
        }
      } catch (err) {
        setCurrencyOptions([]);
      }
    };
    fetchCurrencies();
  }, []);

  useEffect(() => {


    const fetchMetrics = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await axios.get(`${BASE_URL}/v1/metrics/payment-metrics`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        if (res.data && res.data.status && res.data.data) {
          // Remove Array.isArray check since data is an object
          setSelectedMetrics(res.data.data);
        }
      } catch (err) {
        setInvoices([]);
        setSelectedMetrics(null);
      } finally {
        setLoading(false);
      }
    };
    fetchMetrics();
  }, []);


  useEffect(() => {
    const fetchBank = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await axios.get(`${BASE_URL}/v1/get-cash-and-bank`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        const options = Array.isArray(res.data.data)
          ? res.data.data.map((item) => ({
            value: item.id, // use only id
            label: item.gl_name,
          }))
          : [];
        setBankOptions(options);
      } catch (err) {
        setBankOptions([]);
      }
    };
    fetchBank();
  }, []);

  useEffect(() => {
    const fetchBank2 = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await axios.get(`${BASE_URL}/v1/get-cash-and-bank`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        const options = Array.isArray(res.data.data)
          ? res.data.data.map((item) => ({
            value: item.id, // use only id
            label: item.gl_name,
          }))
          : [];
        setBankOptions2(options);
      } catch (err) {
        setBankOptions2([]);
      }
    };
    fetchBank2();
  }, []);

  useEffect(() => {
    const fetchPaymentMode = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await axios.get(`${BASE_URL}/v1/income/get-payment-method-cheque`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        const options = Array.isArray(res.data.data)
          ? res.data.data.map((item) => ({
            value: item.id, // use only id
            label: item.name,
          }))
          : [];
        setPaymentMode(options);
      } catch (err) {
        setPaymentMode([]);
      }
    };
    fetchPaymentMode();
  }, []);
  const resetFormStates = () => {
    setSelectedInvoice(null);
    setDescription("");
    setPaymentAmount("");
    setSelectedPaymentMode(null);
    setSelectedExpense(null);
    setSelectedCurrency(null);
    setSelectedBank(null);
    setChequeNo("");
    setAmount("");  // for Outstanding
  };
  // Supplier Payment modal amount
  const [supplierPaymentAmount, setSupplierPaymentAmount] = useState("");


  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await axios.get(`${BASE_URL}/v1/beneficiary`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });

        const options = res.data.data.map((item) => {
          const latestLedger = item.ledgers?.[item.ledgers.length - 1];
          return {
            value: item.id,
            label: item.name,
            balance: latestLedger ? parseFloat(latestLedger.balance) : parseFloat(item.balance),
          };
        });



        setCustomerOptions(options);
      } catch (err) {
        console.error(err);
        setCustomerOptions([]);
      }
    };

    fetchCustomers();
  }, []);


  const [supplierPayments, setSupplierPayments] = useState([]);


  useEffect(() => {
    const fetchSupplierPayments = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const response = await axios.get(`${BASE_URL}/v1/get_payment_to_supplier`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.data?.status) {
          setSupplierPayments(response.data.data); // depends on API structure
        } else {
          console.error("Failed to fetch supplier payments:", response.data?.message);
        }
      } catch (error) {
        console.error("Error fetching supplier payments:", error);
      }
    };

    fetchSupplierPayments();
  }, []);




  // Skeleton loader rows
  // const SkeletonRows = () => (
  //   <>
  //     {[...Array(5)].map((_, idx) => (
  //       <tr key={idx}>
  //         {Array(10).fill().map((_, i) => (
  //           <td key={i}>
  //             <div className={classes.skeletonLoader}></div>
  //           </td>
  //         ))}
  //       </tr>
  //     ))}
  //   </>
  // );

  // Helper for status
  const statusClass = (status) => {
    if (status === "Success") return classes.greenStatus;
    if (status === "Pending") return classes.yellowStatus;
    return classes.redStatus;
  };

  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css";
    document.head.appendChild(link);
    return () => {
      document.head.removeChild(link);
    };
  }, []);


  useEffect(() => {
    const fetchExpenseAccounts = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await axios.get(`${BASE_URL}/v1/get-expense-account`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        if (res.data && res.data.status && Array.isArray(res.data.data)) {
          const options = res.data.data.map(item => ({
            value: item.id,
            label: item.gl_name,   // ✅ comes from your JSON
          }));
          setExpenseOptions(options);
        }
      } catch (err) {
        console.error("Failed to fetch expense accounts", err);
      }
    };
    fetchExpenseAccounts();
  }, []);


  const addPayment2 = async () => {
    // Validate required fields for supplier payment (description optional)
    if (!paymentTo || !paymentDate || !supplierPaymentAmount || !selectedPaymentMode || !selectedExpense || !selectedCurrency) {
      Swal.fire({
        icon: "warning",
        title: "Missing Fields",
        text: "Please fill in all required fields before saving.",
        confirmButtonColor: "#16a34a",
      });
      return;
    }

    setAddPaymenntLoad2(true);

    try {
      const token = localStorage.getItem("authToken");

      const payload = {
        receipt_for: paymentTo,
        transaction_date: paymentDate,
        description,
        amount: supplierPaymentAmount,
        mode: selectedPaymentMode.value,
        expense_account: selectedExpense.value,
        currency: selectedCurrency.value,
        bank: selectedBank?.value,
        cheque_no: chequeNo,
        credit: selectedBank?.value,
        debit: selectedBank2?.value,
      };

      const res = await axios.post(`${BASE_URL}/v1/pay_supplier`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // Flatten message for Swal
      let message = "Something went wrong";
      if (res.data?.message) {
        if (typeof res.data.message === "string") {
          message = res.data.message;
        } else if (typeof res.data.message === "object") {
          message = Object.values(res.data.message).flat().join("\n");
        }
      }

      if (res.data.status === true || res.data.success) {
        Swal.fire({
          imageUrl: verified,
          title: "Success!",
          text: message,
          confirmButtonText: "Okay",
          imageWidth: 48,
          imageHeight: 48,
          customClass: {
            title: classes.myTitle,
            popup: classes.myText,
            confirmButton: classes.myButton,
          },
          allowOutsideClick: false,
        }).then(() => {
          handleClose2();
          setSupplierPaymentAmount("");
          resetFormStates();
          fetchInvoices();
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Save Failed",
          text: message,
          confirmButtonColor: "#16a34a",
        });
      }

    } catch (err) {
      let errMsg = err.response?.data?.message;
      if (typeof errMsg === "object") {
        errMsg = Object.values(errMsg).flat().join("\n");
      }
      Swal.fire({
        icon: "error",
        title: "Server Error",
        text: errMsg || "Something went wrong. Please try again later.",
        confirmButtonColor: "#16a34a",
      });
    } finally {
      setAddPaymenntLoad2(false);
    }
  };






  //  const handlePrint = (rowData) => {
  //   navigate("/invoice-previeww", {
  //     state: {
  //       invoiceNumber: rowData.invoice_number,
  //       invoiceDate: rowData.invoice_date,
  //       dueDate: rowData.due_date,
  //       customer: {
  //         name: rowData.customer_name,
  //         phone_number: rowData.customer_phone,
  //         email: rowData.customer_email,
  //       },
  //       items: rowData.items,
  //       total: rowData.total,
  //     },
  //   });
  // };

  const handlePrint = (rowData) => {
    navigate("/invoice-previeww", {
      state: { invoice: rowData },
    });
  };
  const [paymentAmount, setPaymentAmount] = useState("");

  // in state hooks:
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState(null);

  const [expenseOptions, setExpenseOptions] = useState([]);
  const [selectedExpense, setSelectedExpense] = useState(null);

  const handleSubmit = (formData) => {
    console.log('Form submitted:', formData);
    // Handle form submission - send to API, etc.
    setIsModalOpen(false);
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const addPayment = async () => {
    // ✅ validate required fields (description optional)
    if (!selectedInvoice || !paymentAmount || !selectedPaymentMode || !selectedExpense || !selectedCurrency) {
      Swal.fire({
        icon: "warning",
        title: "Missing Fields",
        text: "Please fill in all required fields before saving.",
        confirmButtonColor: "#16a34a",
      });
      return;
    }

    setAddPaymenntLoad(true);
    try {
      const token = localStorage.getItem("authToken");

      const payload = {
        receipt_for: selectedInvoice?.value,
        description,
        amount: paymentAmount,
        mode: selectedPaymentMode?.value,
        currency: selectedCurrency?.value,
        bank: selectedBank?.value,           // ✅ only bank_id goes
        expense_account: selectedExpense?.value,
        cheque_no: chequeNo,                 // ✅ stays, if empty backend ignores
      };


      const res = await axios.post(`${BASE_URL}/v1/pay_supplier`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      console.log("Payment response:", res.data);

      if (res.data.status === true || res.data.status === "success" || res.data.success) {
        Swal.fire({
          imageUrl: verified,
          title: "Success!",
          text: res.data.message,   // ✅ always backend message
          confirmButtonText: "Okay",
          imageWidth: 48,
          imageHeight: 48,
          customClass: {
            title: classes.myTitle,
            popup: classes.myText,
            confirmButton: classes.myButton,
          },
          allowOutsideClick: false,
        }).then(() => {
          handleClose1();
          resetFormStates();
          fetchInvoices();
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Save Failed",
          text: res.data.message,   // ✅ always backend message
          confirmButtonColor: "#16a34a",
        });
      }

    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Server Error",
        text: err.response?.data?.message || "Something went wrong. Please try again later.",
        confirmButtonColor: "#16a34a",
      });


    } finally {
      setAddPaymenntLoad(false);
    }
  };
  console.log("Invoices API response:", invoices);




  const [paymentTo, setPaymentTo] = useState("");


  return (
    <div>
      <HeaderNav activePage={pageMap[location.pathname]} />

      <div className={classes.Container}>
        {/* <div className={classes.actions}>

                    <button className={`${classes.btnss} ${classes.greens}`}>New Sales Invoice</button>
                    <button className={classes.btns}>New Purchase Invoice</button>
                    <button className={classes.btns}>All Invoices</button>
                    <button className={classes.btns}>Product & Services </button>

                </div> */}
        <div className={classes.actionsbtn}>
          <button className={classes.btns}>New Sales Invoice</button>
          <button className={classes.btns}>New Purchase Invoice</button>
          <button className={classes.btns}>All Invoices</button>
          <button className={`${classes.btns} ${classes.greens}`}>Product & Services</button>
        </div>

        <header className={classes.Header}>
          <h2 className={classes.Title}>Payments</h2>
          <h1 className={classes.Titles}>
            Manage your purchase transactions, supplier invoices, and payments.
          </h1>
        </header>

        <Row>
          <Col md={4}>
            <div className={classes.thrdkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Total Payment</p>
                <p className={classes.kdptg1}>
                  ₦{selectMetrics?.total?.toLocaleString() ?? '0'}
                </p>
                <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>This month</p>
                </div>
              </div>
            </div>
          </Col>
          <Col md={4}>
            <div className={classes.frtkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Completed</p>
                <p className={classes.kdptg2}>
                  ₦{selectMetrics?.completed?.toLocaleString() ?? '0'}
                </p>
                <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>Completed payments</p>
                </div>
              </div>
            </div>
          </Col>
          <Col md={4}>
            <div className={classes.fiftkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Total</p>
                <p className={classes.kdptg3}>
                  ₦{selectMetrics?.totalpayments?.toLocaleString() ?? '0'}
                </p>
                <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>Total payment</p>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <div className={classes.headerActions}>
          <div className={classes.actionsRight}>
            <div className={classes.inputWrapper}>
              <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
              <input type="text" className={classes.searchBar} placeholder="Search sales" />
            </div>
            <div className={classes.selectWrapper}>
              <select className={classes.dropdown}>
                <option value="">All Status</option>
                <option value="Paid">Paid</option>
                <option value="Pending">Pending</option>
                <option value="Overdue">Overdue</option>
                <option value="Draft">Draft</option>
              </select>
              <span className={classes.dropdownArrow}>▼</span>
            </div>

            <div className={classes.inputWrapper}>
              <input type="text" className={classes.searchBars} placeholder="Filter..." />
              <img src={filter} alt="Filter" className={classes.inputIcon} />
            </div>
          </div>
          <div className={classes.actionsLeft}>
            <button onClick={() => setIsModalOpen(true)} className={classes.btnss}>
              + New Payment
            </button>
            {/* <button className={classes.btnss} onClick={() => setIsOpen(true)}> New Payment</button> */}
            <button className={classes.btnss} onClick={handleShow2}> Petty Cash</button>
          </div>
        </div>

        <div className={classes.invoicecont}>
          <table className={classes.invoiceTable}>
            <thead style={{ whiteSpace: "nowrap" }}>
              <tr>
                <th>S/N</th>
                <th>Invoice Number</th>
                <th>Supplier Name</th>
                <th>Description</th>
                <th>Date</th>
                <th>Currency</th>
                <th>Rate</th>
                <th>Payment Status</th>
                <th>Equivalent Rate</th>
                <th>Payment Mode</th>
                <th>Amount</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                Array(5).fill().map((_, idx) => (
                  <tr key={idx}>
                    {Array(12).fill().map((_, i) => (
                      <td key={i}>
                        <Skeleton height={20} style={{ marginBottom: 10 }} />
                      </td>
                    ))}
                  </tr>
                ))
              ) : invoices.length === 0 ? (
                <tr>
                  <td colSpan={12} style={{ textAlign: "center" }}>
                    No purchase invoices found.
                  </td>
                </tr>
              ) : (
                invoices.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>{item.invoice_number}</td>
                    <td>{item.supplier?.name || item.supplier_id || ""}</td>

                    <td>{item.description || "-"}</td>
                    <td>{item.transaction_date}</td>


                    <td>{currencyOptions.find(c => c.value === Number(item.currency))?.label || 'N/A'}</td>



                    <td className={classes.rightAlign}>
                      {/* Rate calculation */}
                      {item.currency_amount && item.converted_amount
                        ? (Number(item.converted_amount) / Number(item.currency_amount)).toLocaleString()
                        : "-"}
                    </td>


                    {/* Payment Status */}
                    <td
                      className={statusClass(
                        Number(item.balance) === 0
                          ? "Success"
                          : Number(item.paid) > 0
                            ? "Pending"
                            : "Pending"
                      )}
                    >
                      {Number(item.balance) === 0
                        ? "Paid"
                        : Number(item.paid) > 0
                          ? "Partially Paid"
                          : "Pending"}
                    </td>

                    {/* Equivalent Rate */}
                    <td className={classes.rightAlign}>
                      {/* Show equivalent in base currency if rate exists */}
                      {item.rate
                        ? (Number(item.amount) * Number(item.rate.rate)).toLocaleString()
                        : Number(item.amount).toLocaleString()}
                    </td>
                    <td>{paymentMode.find(m => m.value === Number(item.payment_mode))?.label || '-'}</td>
                    <td className={classes.rightAlign}>{Number(item.amount).toLocaleString()}</td>
                    <td className={classes.actionsCell}>
                      <div className={classes.actions}>
                        <Pen size={16} className={classes.editIcon} />
                        <Trash2 size={16} className={classes.deleteIcon} />
                        <Printer
                          size={16}
                          className={classes.printIcon}
                          onClick={() => handlePrint(item)}
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          <div className={classes.paginationContainer}>
            <div className={classes.paginationControls}>
              <button>First</button>
              <button className={classes.active}>1</button>
              <button>Last</button>
              <span className={classes.pageText}>Displaying 1 - 41 of 41</span>
            </div>
          </div>
        </div>

      </div>
      <Modal
        show={isOpen}
        onHide={() => setIsOpen(false)}
        className={classes.customModal}
      >
        <Modal.Body>
          <Modal.Header closeButton>
            <Modal.Title>New Payment</Modal.Title>
          </Modal.Header>


          <Form className={classes.compactForm}>
            {/* Payment To / Supplier */}
            <div className={classes.compactRow}>
              <label>Payment To:</label>
              <Select
                options={customerOptions}
                value={selectedInvoice}
                onChange={(option) => {
                  setSelectedInvoice(option);
                  setAmount(option?.balance || 0);  // use 0 as fallback
                }}

                placeholder="Select or Enter Customer"
                isClearable
                classNamePrefix="react-select"
              />

            </div>

            {/* Description */}
            <div className={classes.compactRow}>
              <label>Description:</label>
              <Form.Control
                as="textarea"
                value={description}
                rows={2}
                onChange={(e) => {
                  const filteredValue = e.target.value.replace(/[^a-zA-Z0-9.@,\- ]/g, '');
                  setDescription(filteredValue);
                }}
                placeholder="Enter description"
                className={classes.fullWidth}
                required
              />
            </div>

            {/* Payment Mode */}
            <div className={classes.compactRow}>
              <label>Mode:</label>
              <Select
                options={paymentMode}
                value={selectedPaymentMode}
                onChange={setSelectedPaymentMode}
                placeholder="Select Payment Mode"
                isClearable
                classNamePrefix="react-select"
                required
              />
            </div>

            <div className={classes.compactRow}>
              <label>Currency:</label>
              <Select
                options={currencyOptions}
                value={selectedCurrency}
                onChange={setSelectedCurrency}
                placeholder="Select Currency"
                isClearable
                classNamePrefix="react-select"
                required
              />
            </div>


            {/* Expense Account */}
            <div className={classes.compactRow}>
              <label>Expense Account:</label>
              <Select
                options={expenseOptions}
                value={selectedExpense}
                onChange={setSelectedExpense}
                placeholder="Select Expense Account"
                isClearable
                classNamePrefix="react-select"
              />
            </div>

            <div className={classes.compactRow}>
              <label>Outstanding:</label>
              <CurrencyInput
                id="total-amount"
                name="totalAmount"
                value={amount}   // 🔴 currently tied to "amount"
                decimalsLimit={2}
                // prefix="₦"
                groupSeparator=","
                placeholder="Enter Outstanding"
                className={`form-control ${classes.optioncss}`}
                disabled   // ✅ makes it read-only/uneditable
              />
            </div>

            <div className={classes.compactRow}>
              <label>Amount:</label>
              <CurrencyInput
                id="payment-amount"
                name="paymentAmount"
                value={paymentAmount}   // ✅ create new state for this
                decimalsLimit={2}
                onValueChange={(value) => setPaymentAmount(value)}
                // prefix="₦"
                groupSeparator=","
                placeholder="Enter Payment Amount"
                className={`form-control ${classes.optioncss}`}
              />
            </div>




            <div className={classes.compactRow}>
              <label>Bank:</label>
              <Select
                options={bankOptions}
                value={selectedBank}
                onChange={setSelectedBank}
                placeholder="Select Bank"
                isClearable
                classNamePrefix="react-select"
                required
              />
            </div>



            {/* Cheque / Teller No */}
            <div className={classes.inputGroup}>
              <label htmlFor="chequeNo">Cheque / Teller No</label>
              <input
                type="text"
                id="chequeNo"
                value={chequeNo}
                onChange={(e) => setChequeNo(e.target.value)}
                placeholder="Enter cheque number"
                className={`form-control ${classes.optioncss}`}
              />
            </div>

          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className={classes.customCancelBtn}
            onClick={handleClose1}   // ✅ fixed
          >
            Cancel
          </Button>
          <Button
            className={classes.customSaveBtn}
            onClick={addPayment}     // ✅ fixed
            disabled={addpaymenntLoad}
          >
            {addpaymenntLoad ? "Processing..." : "Save"}
          </Button>
        </Modal.Footer>

      </Modal>



      <Modal show={show2} onHide={handleClose2} animation={false} className={classes.customSupplierModal}>
        <Modal.Header closeButton>
          <Modal.Title>Petty Cash</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Row style={{ marginBottom: "15px" }}>
                {/* Payment To */}
                <Col md={12} style={{ marginBottom: 10 }}>
                  <Row>
                    <Col md={3} style={{ textAlign: "right" }}>
                      <label>Payment to:</label>
                    </Col>
                    <Col md={9}>
                      <input
                        type="text"
                        value={paymentTo}
                        onChange={(e) => setPaymentTo(e.target.value)}
                        placeholder="Enter Supplier Name"
                        className={`form-control ${classes.optioncss}`}
                      />
                    </Col>
                  </Row>
                </Col>

                {/* Date */}
                <Col md={12} style={{ marginBottom: 10 }}>
                  <Row>
                    <Col md={3} style={{ textAlign: "right" }}>
                      <label style={{ width: "100%" }}>Date:</label>
                    </Col>
                    <Col md={9}>
                      <input
                        type="date"
                        value={paymentDate}
                        onChange={(e) => setPaymentDate(e.target.value)}
                        required
                        style={{ width: "100%" }}
                      />
                    </Col>
                  </Row>
                </Col>

                {/* Description */}
                <Col md={12} style={{ marginBottom: 10 }}>
                  <Row>
                    <Col md={3} style={{ textAlign: "right" }}>
                      <label style={{ width: "100%" }}>Description:</label>
                    </Col>
                    <Col md={9}>
                      <Form.Control
                        as="textarea"
                        value={description}
                        rows={1}
                        onChange={(e) => {
                          const value = e.target.value;
                          const filteredValue = value.replace(/[^a-zA-Z0-9.@,\- ]/g, '');
                          setDescription(filteredValue);
                        }}
                        required
                        style={{ width: "100%" }}
                      />
                    </Col>
                  </Row>
                </Col>

                {/* ✅ Mode + Currency Side by Side */}
                <Col md={12} style={{ marginTop: "15px" }}>
                  <Row>
                    <Col md={6}>
                      <Row>
                        <Col md={4} style={{ textAlign: "right" }}>
                          <label>Mode:</label>
                        </Col>
                        <Col md={8}>
                          <Select
                            options={paymentMode}
                            value={selectedPaymentMode}
                            onChange={setSelectedPaymentMode}
                            placeholder=" Payment Mode"
                            isClearable
                            classNamePrefix="react-select"
                            required
                          />
                        </Col>
                      </Row>
                    </Col>

                    <Col md={6}>
                      <Row>
                        <Col md={4} style={{ textAlign: "right" }}>
                          <label>Currency:</label>
                        </Col>
                        <Col md={8}>
                          <Select
                            options={currencyOptions}
                            value={selectedCurrency}
                            onChange={setSelectedCurrency}
                            placeholder="Currency"
                            isClearable
                            classNamePrefix="react-select"
                            required
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>

                {/* Expense Account */}
                <Col md={12} style={{ marginTop: "15px" }}>
                  <Row>
                    <Col md={3} style={{ textAlign: "right" }}>
                      <label>Expense Account:</label>
                    </Col>
                    <Col md={9}>
                      <Select
                        options={expenseOptions}
                        value={selectedExpense}
                        onChange={setSelectedExpense}
                        placeholder="Select Expense Account"
                        isClearable
                        classNamePrefix="react-select"
                      />
                    </Col>
                  </Row>
                </Col>

                {/* Amount */}
                <Col md={12} style={{ marginTop: "15px" }}>
                  <Row>
                    <Col md={3} style={{ textAlign: "right" }}>
                      <label>Amount:</label>
                    </Col>
                    <Col md={9}>
                      <CurrencyInput
                        id="supplier-payment-amount"
                        name="supplierPaymentAmount"
                        value={supplierPaymentAmount}
                        decimalsLimit={2}
                        onValueChange={(value) => setSupplierPaymentAmount(value)}
                        prefix=""
                        groupSeparator=","
                        placeholder="Enter Amount"
                        className={`form-control ${classes.optioncss}`}
                      />
                    </Col>
                  </Row>
                </Col>

                {/* ✅ Bank + Cheque No Side by Side */}
                <Col md={12} style={{ marginTop: "15px" }}>
                  <Row>
                    <Col md={6}>
                      <Row>
                        <Col md={4} style={{ textAlign: "right" }}>
                          <label>Bank:</label>
                        </Col>
                        <Col md={8}>
                          <Select
                            options={bankOptions}
                            value={selectedBank}
                            onChange={setSelectedBank}
                            placeholder="Select Account"
                            isClearable
                            classNamePrefix="react-select"
                            required
                          />
                        </Col>
                      </Row>
                    </Col>

                    <Col md={6}>
                      <Row>
                        <Col md={4} style={{ textAlign: "right" }}>
                          <label>Cheque No:</label>
                        </Col>
                        <Col md={8}>
                          <input
                            type="text"
                            id="chequeNo"
                            value={chequeNo}
                            onChange={(e) => setChequeNo(e.target.value)}
                            placeholder="Enter cheque number"
                            className={`form-control ${classes.optioncss}`}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button className={classes.customCancelBtn} onClick={handleClose2}>
            Cancel
          </Button>
          <Button
            className={classes.customSaveBtn}
            onClick={addPayment2}
            disabled={addpaymenntLoad2}
          >
            {addpaymenntLoad2 ? "Processing..." : "Save"}
          </Button>
        </Modal.Footer>
      </Modal>


      <PaymentModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={handleSubmit}
      />
      <Footer />
    </div>
  );
};

export default NewPaymentPage;
